import { Card, CardActionArea, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { KeyboardArrowRightRounded } from '@material-ui/icons';
import { Link as RRLink, Redirect, useParams } from 'react-router-dom';
import Breadcrumb from '../Breadcrumb';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: theme.spacing(1.5, 0, 12, 0)
    },
    title: {
      margin: theme.spacing(1.5, 0, 2, 0),
      [theme.breakpoints.down('xs')]: {
        textAlign: 'center',
        margin: theme.spacing(3.5, 0, 4, 0)
      }
    },
    card: {
      display: 'flex',
      margin: theme.spacing(0, 0, 1.5, 0),
      '&:last-child': {
        marginBottom: 0
      },
      width: '100%',
      border: '2px solid',
      borderColor: theme.palette.background.paper,
      borderRadius: 16,
      transition: '0.4s',
      '&:hover, &.Mui-focusVisible': {
        borderColor: theme.palette.primary.main
      }
    },
    textArea: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: theme.spacing(1, 1, 1, 2)
    }
  })
);

export const HELP_TOPICS = [
  {
    helpTopicId: 'projects',
    labelKey: 'help.topics.projects.label',
    subTopics: [
      { nameKey: 'help.subtopics.setupProject', to: '/helps/projects/setup-project' },
      {
        nameKey: 'help.subtopics.setupProjectWorkflow',
        to: '/helps/projects/setup-project-workflow'
      },
      {
        nameKey: 'help.subtopics.manageMembers',
        to: '/helps/projects/manage-member'
      }
    ]
  },
  {
    helpTopicId: 'documents',
    labelKey: 'help.topics.documents.label',
    subTopics: [
      { nameKey: 'help.subtopics.planDocument', to: '/helps/documents/plan-document' },
      {
        nameKey: 'help.subtopics.createDocumentWorkflow',
        to: '/helps/documents/create-document-workflow'
      },
      {
        nameKey: 'help.subtopics.reviewApproveDocument',
        to: '/helps/documents/review-approve-document'
      },
      {
        nameKey: 'help.subtopics.followUpDocument',
        to: '/helps/documents/follow-up-document'
      }
    ]
  },
  {
    helpTopicId: 'permissions',
    labelKey: 'help.topics.permissions.label',
    subTopics: [
      {
        nameKey: 'help.subtopics.documentAccessControl',
        to: '/helps/permissions/document-access-control'
      },
      {
        nameKey: 'help.subtopics.userAccessControl',
        to: '/helps/permissions/user-access-control'
      }
    ]
  }
];

export default function HelpTopic() {
  const classes = useStyles();
  const { t } = useTranslation();
  const { helpTopicId } = useParams<{ helpTopicId: string }>();

  const helpTopic = HELP_TOPICS.find(
    (helpTopic) => helpTopic.helpTopicId === helpTopicId
  );

  if (!helpTopic) {
    return <Redirect to="/helps" />;
  }

  return (
    <div className={classes.root}>
      <Breadcrumb
        name="helpTopic"
        data={{ helpTopic: helpTopic ? t(helpTopic.labelKey) : '', helpTopicId }}
      />
      {
        <>
          <Typography className={classes.title} variant="h4">
            {helpTopic ? t(helpTopic.labelKey) : ''}
          </Typography>
          {helpTopic?.subTopics.map((subTopic) => {
            return (
              <Card className={classes.card} key={subTopic.to}>
                <CardActionArea
                  className={classes.textArea}
                  component={RRLink}
                  to={subTopic.to}
                >
                  <Typography>{t(subTopic.nameKey)}</Typography>
                  <KeyboardArrowRightRounded />
                </CardActionArea>
              </Card>
            );
          })}
        </>
      }
    </div>
  );
}
